module.exports = __webpack_public_path__ + "img/09.36c67d19.png";